import { connect } from "react-redux";
import { Modal } from "bootstrap";
import AppBaseComponent from '../../../../components/AppBaseComponent';
import HttpAPICall from "../../../../services/HttpAPICall";
import Loader from "../../../../components/ui/Loader/Loader";
import tapIcon from "../../../../services/TapIcon";
import Ax from "../../../../components/hoc/Ax";
import { toast } from "react-toastify";
import React from "react";
import swal from "sweetalert";
import { IAM_API_BASE_URL_2 } from "../../../../services/TapApiUrls";
import CreatableSelect from 'react-select/creatable';
import Status from "../../../../components/ui/Status";
import TapSelect from '../../../../components/ui/TapSelect';


class UnitList extends AppBaseComponent {

    constructor(props) {
        super(props);

        this.initMergeUnitForm = {
            id: '',
            name: '',
            merge_to_id: '',
        };

        this.state = {
            unit_loading: false,
            unit_list: null,
            unitMergeForm: { ...this.initMergeUnitForm },
            mergeFormSubmiting: false,
        };
    }

    componentDidMount() {
        this.getUnitList();
        this.mergeUnitForm = new Modal(document.getElementById('mergeUnitFormModal'), { keyboard: false, backdrop: false });

    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.configurationChanged !== this.props.configurationChanged) {
            this.getUnitList();
        }
    }

    getUnitList = () => {
        this.setState({ unit_loading: true })
        HttpAPICall.withAthorization('GET', IAM_API_BASE_URL_2 + '/activity_name/unit_list', this.props.access_token, {}, {}, (resp) => {
            this.setState({ unit_list: resp.data })
        }).then(() => this.setState({ unit_loading: false }));
    }



    mergeUnitName = (data) => {
        this.setState({
            unitMergeForm: {
                id: data.id,
                name: data.measuring_unit,
                merge_to_id: ''
            }
        }, () => {
            this.mergeUnitForm.show();
        });
    };

    submitMergeUnitForm = (e) => {
        e.preventDefault();

        if (!this.state.unitMergeForm.merge_to_id) {
            toast.error("Please select Merge To Unit");
            return;
        }

        this.setState({ mergeFormSubmiting: true });

        const payload = {
            id: this.state.unitMergeForm.id,
            merge_to_id: this.state.unitMergeForm.merge_to_id
        };

        HttpAPICall.withAthorization(
            'PUT',
            IAM_API_BASE_URL_2 + '/activity_name/unit_merge',
            this.props.access_token,
            {},
            payload,
            (response) => {
                toast.success(response.message || "Unit merged successfully");

                this.mergeUnitForm.hide();

                this.setState({
                    unitMergeForm: {
                        ...this.initMergeUnitForm
                    }
                });

                this.getUnitList();
            }
        )
            .catch(() => {
                this.setState({ mergeFormSubmiting: false });
            })
            .finally(() => {
                this.setState({ mergeFormSubmiting: false });
            });
    };



    mergeUnitFormModalJsx = () => {
        const unitOptions =
            this.state.unit_list
                ?.filter(
                    item => item.id !== this.state.unitMergeForm.id
                )
                .map(item => ({
                    value: item.id,
                    label: item.measuring_unit
                })) || [];
        return (
            <div className="modal fade" id="mergeUnitFormModal" tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="mergeAssetModalLabel">Merge Unit</h5>
                        </div>
                        <form onSubmit={this.submitMergeUnitForm}>
                            <div className="modal-body">

                                <div className="row mb-3">
                                    <label className="col-sm-3 col-form-label col-form-label-sm">
                                        Unit Name
                                    </label>

                                    <div className="col-sm-7">
                                        <input className="form-control form-control-sm"
                                            value={this.state.unitMergeForm.name}
                                            disabled={true} />
                                    </div>
                                </div>

                                <div className="row mb-3">
                                    <label className="col-sm-3 col-form-label col-form-label-sm require">
                                        Merge To
                                    </label>

                                    <div className="col-sm-7">
                                        <TapSelect
                                            options={unitOptions}
                                            changeEvent={(selectedOption) => {
                                                this.setState({
                                                    unitMergeForm: {
                                                        ...this.state.unitMergeForm,
                                                        merge_to_id: selectedOption?.value || ''
                                                    }
                                                });
                                            }}
                                            value={
                                                unitOptions.find(
                                                    s =>
                                                        s.value ==
                                                        this.state.unitMergeForm.merge_to_id
                                                ) || null
                                            }
                                            required={true}
                                            isSearchable={true}
                                            isClearable={true}
                                            placeholder="Select Unit"
                                            containerHeight="30px"
                                            fontSize="93%"
                                        />
                                    </div>
                                </div>

                            </div>

                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-bs-dismiss="modal"
                                >
                                    Close
                                </button>

                                <button
                                    type="submit"
                                    className="btn btn-primary"
                                    disabled={this.state.mergeFormSubmiting}
                                >
                                    Merge
                                    {this.state.mergeFormSubmiting && (
                                        <tapIcon.FontAwesomeIcon
                                            icon={tapIcon.faSyncAlt}
                                            className="fa-spin ms-1"
                                        />
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
    render = () => {

        return (<Ax>
            <div className="tab_content_wrapper mt-2"><span className="content_heading">Unit Name List</span>
            </div>
            <table className="table table-hover table-bordered my-4 ">
                <thead className="table-secondary">
                    <tr className="text-center">
                        <th scope="col" style={{ width: "10%" }}>S.No</th>
                        <th scope="col">Unit Name</th>
                        <th scope="col" style={{ width: "35%" }} >UOM</th>
                        <th scope="col" style={{ width: "10%" }} >Action</th>
                    </tr>
                </thead>
                <tbody>
                    {this.state.unit_loading
                        ? <tr className="text-center"><td colSpan={4}><Loader /></td></tr>
                        : this.state.unit_list && this.state.unit_list.length > 0
                            ? this.state.unit_list.map((mt, index) => {
                                return (<tr className="text-center"  key={mt.id}>
                                    <td >{index + 1}</td>
                                    <td className="text-start">{mt.measuring_unit ? mt.measuring_unit : ""} {mt.is_global == 'Y' ? <sup className="form-text">*</sup> : null}</td>
                                    <td className="text-start">{mt.symbol ? mt.symbol : ""}</td>
                                    <td> <tapIcon.imageIcon icon={tapIcon.ListActionIcon} alt="action-icon" className="img-fluid pr10 pl10" data-bs-toggle="dropdown" href="#"
                                        role="button" aria-expanded="false" />
                                        <ul className="dropdown-menu" style={{ cursor: "pointer" }} >
                                            <li
                                                className={`dropdown-item ${mt.is_global != 'N' ? 'disabled text-muted' : ''}`}
                                                onClick={() => {
                                                    if (mt.is_global === 'N') {
                                                        this.mergeUnitName(mt);
                                                    }
                                                }}
                                            >
                                                Merge unit
                                            </li>
                                        </ul>
                                    </td>
                                </tr>)
                            })
                            : <tr className="text-center"><td colSpan={4}>No Records</td></tr>}

                </tbody>
            </table>
            <div className="form-text my-2">* Global Unit</div>
            {this.mergeUnitFormModalJsx()}
        </Ax>);
    }

}


const mapStateToProps = state => {
    return {
        access_token: state.auth.access_token
    };
};

export default connect(mapStateToProps)(UnitList);